$(document).ready(function() {
    if ($('body.page-prenota').length) {
        let viewContractVideoconsulto = false;
        $('#condizione_utente').on('change', (e) => {
            if ( $(e.delegateTarget).prop('checked') == true &&  viewContractVideoconsulto == false) {
                $('[data-html="contratto"]').trigger('click');
            }
        });

        $('[data-html="contratto"]').on('click', function(e) {
            viewContractVideoconsulto= true;
        });

        $('#prenota-altri-btn').on('change', function () {
            if ($(this).prop('checked') == true) {
                $('#prenota-altri').slideDown();
            } else {
                $('#prenota-altri').slideUp();
            }
        });

        $('#btnRemovePrenotaAltraPersona').on('click', function () {
            $('#prenota-altri-btn').prop('checked', false).trigger('change');
            $('#alertDatiIncompleti').slideUp();
            $('#prenota-altri .form-control').val('');
            $('#user_registration').submit();
        });

        $('#user_registration').on('submit', function (e) {
            let btn = $('#user_registration').find('.btn.btn-primary');
            btn.prop('disabled', true);
            btn.html('<i class="fas fa-spinner fa-spin"></i> ' + btn.html());
        });

        $('#riepilogo-cambia-prest').on('click', function(e) {
            let idStudio = $('#box-riepilogo-dati').data('studio');
            let idPrestazione = $(this).data('id');
        })

        $('#riepilogo-cambia-data').on('click', async (e) => {
            
            let idStudio = $('#box-riepilogo-dati').data('studio');
            let idMedico = $('#box-riepilogo-dati').data('medico');
            let idPrestazione = $('#box-riepilogo-dati').data('prestazione');
            let idKeyword = $('#box-riepilogo-dati').data('keyword');
            let data = $('#box-riepilogo-dati').data('giorno');
            let ora = $('#box-riepilogo-dati').data('ora');
            $('#modal-change-disp .modal-title').html('Cambia data');
            
            const disp = await getDisponibilitaMedico(idMedico, idStudio, idPrestazione, idKeyword, data, ora);

            let giorni = [];
            if (disp.length) {
                giorni = disp.filter((k, i) => {
                    return k.giorno != data && i < 6;
                }).map(k => {
                    return {
                        giorno: k.giorno,
                        listOrari: k.listOrari
                    }
                })
            }
            showModalChangeDisp(giorni);
        })

        $('#riepilogo-cambia-ora').on('click', async (e) => {
            let idStudio = $('#box-riepilogo-dati').data('studio');
            let idMedico = $('#box-riepilogo-dati').data('medico');
            let idPrestazione = $('#box-riepilogo-dati').data('prestazione');
            let idKeyword = $('#box-riepilogo-dati').data('keyword');
            let data = $('#box-riepilogo-dati').data('giorno');
            let ora = $('#box-riepilogo-dati').data('ora');
            $('#modal-change-disp .modal-title').html('Cambia orario');

            const disp = await getDisponibilitaMedico(idMedico, idStudio, idPrestazione, idKeyword, data, ora);

            let giorni = [];
            if (disp.length) {
                giorni = disp.filter((k) => {
                    return k.giorno == data;
                }).map(k => {
                    return {
                        giorno: k.giorno,
                        listOrari: k.listOrari.filter(o => o.ora_inizio + ':00' != ora)
                    }
                })
            }
            showModalChangeDisp(giorni);
        })

        window.showModalChangeDisp = function (disp) {
            let html = '<div class="text-center alert alert-danger lead">In questo studio non ci sono altri orari disponibili</div>';
            let count = 0;
            if (disp.length) {
                html = '';
                disp.forEach((d) => {
                    html += `<div class="row py-2">
                                <div class="col-12">
                                    <div class="card border-0">
                                        <div class="card-body">
                                        <h6 class="text-capitalize">${moment(d.giorno).format('dddd DD MMMM YYYY')}</h6>
                                        <ul class="list-inline mb-0">`;
                                        d.listOrari.forEach((o) => {
                                            html += `<li class="list-inline-item"><a href="${o.destination}" class="btn btn-primary btn-sm my-1">${o.ora_inizio}</a></li>`;
                                        });
                                        html += `</ul>
                                        </div>
                                    </div>
                                </div>
                            </div>`;
                            count++;
                            if (count == 3) {
                                return false;
                            }
                });
            }
            $('#modal-change-disp .modal-body').html(html);
            $('#modal-change-disp').modal('show');
        }

        window.getDisponibilitaMedico = async function(idMedico, idStudio, idPrestazione, idKeyword) {
            try {
                const onResult = await httpRequest(api_url + 'frontend/medico/disponibilita', {
                    idMedico: idMedico, 
                    idPrestazione: idPrestazione,
                    idStudio: idStudio,
                    idKeyword: idKeyword
                });

                if (onResult.result) {
                    return onResult.data.listDisp;
                }
            } catch (error) {
                return showError('Si è verificato un errore');
            }

            
            return null;
        }

        window.requestPaymentRegion = function (e) {
            /**
             * Nel pagamento anticipato, se selezionano paga in struttura faccio il submit del form senza il pagamento
             */
            if ($('#pagamento-anticipato-choser').length && $('[name="metodopagamento"]:checked').val() == 1) {
                $('#user_registration').submit();
                return false;
            }
            $('#conferma-prenotazione').slideToggle();
            $('#payment-region').slideToggle();
            $('html, body').animate({
                scrollTop: 0
            }, 1000);
        }
    }
});